<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-calendar-account"
      inline
      class="px-5 py-3"
      title="Consultas profesionales"
    >
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="consultas"
        :search.sync="search"
        :sort-by="['fullName']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-if="esMedico" v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="goToConsulta(item)"
              >
                mdi-file-document-edit
              </v-icon>
            </template>
            <span>Asignar turno</span>
          </v-tooltip>
          <v-tooltip v-if="esJugador" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-cancel
              </v-icon>
            </template>
            <span>Cancelar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        esJugador: false,
        esMedico: false,
        search: undefined,
        headers: [
          { text: 'Solicitado', sortable: true, value: 'fecha_solicitud' },
          { text: 'Jugador', sortable: true, value: 'jugador' },
          { text: 'Profesional', sortable: true, value: 'medico' },
          { text: 'Especialidad', sortable: true, value: 'especialidad' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        consultas: [],
        editedIndex: -1,
        dataForm: {

        },
      }
    },

    created () {
      this.setJugador()
      this.setMedico()
      this.getConsultas()
    },

    methods: {

      getConsultas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/consulta_medica_pendiente' }).then(response => { this.consultas = response })
      },

      setJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador_loged' }).then(response => {
          if (response) {
            this.esJugador = true
          }
        })
      },

      setMedico: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_loged_medico' }).then(response => {
          if (response) {
            this.esMedico = true
          }
        })
      },

      goToConsulta: async function (item) {
        this.$router.push({ name: 'Alta consulta profesional', params: { id: item.id, mode: 'edit' } })
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', '¿Está seguro de cancelar el turno?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/consulta_medica_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Consulta eliminada'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getConsultas()
      },
    },
  }
</script>
